
const ErrorMessage = ({ type, message }) => {


    return <div className="text-center">
        {message}
    </div>
}
export default ErrorMessage;